import {
  CalculatorIcon,
  FileCheckIcon,
  LineChartIcon,
  PresentationIcon,
  ScaleIcon,
  UsersIcon,
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Menu,
  X,
  ChevronsUpDown,
  LogOut,
  Sparkles,
  Sun,
  Moon,
  ChevronRight,
  ChevronDown,
  Settings2,
  BookOpen,
  MoreHorizontal,
  Folder,
  AlertOctagonIcon,
  FilePlus2,
  DollarSign,
  FileText,
  PlusCircle,
  FilePen,
  BookUser,
  Loader2,
  Landmark,
  ChevronLeft,
  Plus,
  Ellipsis,
  User,
  Info,
  LibraryBig,
  ArrowRightLeft
} from 'lucide-react'

export type IconName =
  | 'Alert'
  | 'ArrowLeft'
  | 'LineChart'
  | 'Scale'
  | 'Presentation'
  | 'Calculator'
  | 'FileCheck'
  | 'Users'
  | 'Facebook'
  | 'Twitter'
  | 'Linkedin'
  | 'Instagram'
  | 'Menu'
  | 'X'
  | 'ChevronsUpDown'
  | 'LogOut'
  | 'Sparkles'
  | 'Sun'
  | 'Moon'
  | 'ChevronRight'
  | 'ChevronDown'
  | 'Settings'
  | 'BookOpen'
  | 'More'
  | 'Folder'
  | 'FilePlus'
  | 'PlusCircle'
  | 'Money'
  | 'FileText'
  | 'BookUser'
  | 'Loader'
  | 'FilePen'
  | 'Bank'
  | 'Plus'
  | 'Ellipsis'
  | 'User'
  | 'Info'
  | 'Library'
  | 'ArrowRightLeft'
interface IconProps {
  name: IconName
  className?: string
}

export default function Icon({ name, ...props }: IconProps) {
  switch (name) {
    case 'LineChart':
      return <LineChartIcon {...props} />
    case 'Scale':
      return <ScaleIcon {...props} />
    case 'Presentation':
      return <PresentationIcon {...props} />
    case 'Calculator':
      return <CalculatorIcon {...props} />
    case 'FileCheck':
      return <FileCheckIcon {...props} />
    case 'Users':
      return <UsersIcon {...props} />
    case 'User':
      return <User {...props} />
    case 'Facebook':
      return <Facebook {...props} />
    case 'Twitter':
      return <Twitter {...props} />
    case 'Linkedin':
      return <Linkedin {...props} />
    case 'Instagram':
      return <Instagram {...props} />
    case 'Menu':
      return <Menu {...props} />
    case 'X':
      return <X {...props} />
    case 'ChevronsUpDown':
      return <ChevronsUpDown {...props} />
    case 'LogOut':
      return <LogOut {...props} />
    case 'Sparkles':
      return <Sparkles {...props} />
    case 'Sun':
      return <Sun {...props} />
    case 'Moon':
      return <Moon {...props} />
    case 'ChevronRight':
      return <ChevronRight {...props} />
    case 'ChevronDown':
      return <ChevronDown {...props} />
    case 'Settings':
      return <Settings2 {...props} />
    case 'BookOpen':
      return <BookOpen {...props} />
    case 'More':
      return <MoreHorizontal {...props} />
    case 'Folder':
      return <Folder {...props} />
    case 'Alert':
      return <AlertOctagonIcon {...props} />
    case 'FilePlus':
      return <FilePlus2 {...props} />
    case 'Money':
      return <DollarSign {...props} />
    case 'FileText':
      return <FileText {...props} />
    case 'PlusCircle':
      return <PlusCircle {...props} />
    case 'BookUser':
      return <BookUser {...props} />
    case 'Loader':
      return <Loader2 {...props} />
    case 'FilePen':
      return <FilePen {...props} />
    case 'Bank':
      return <Landmark {...props} />
    case 'ArrowLeft':
      return <ChevronLeft {...props} />
    case 'Plus':
      return <Plus {...props} />
    case 'Ellipsis':
      return <Ellipsis {...props} />
    case 'Info':
      return <Info {...props} />
    case 'Library':
      return <LibraryBig {...props} />
    case 'ArrowRightLeft':
      return <ArrowRightLeft {...props} />
    default:
      console.warn(`Icone [${name}] não implementado`)
      break
  }
}
